export function parseRoute(hash) {
    if (!hash || hash === "#" || hash === "#/")
        return { name: "home" };
    const m1 = hash.match(/^#\/case\/([^/]+)$/);
    if (m1)
        return { name: "case", id: m1[1] };
    const mb = hash.match(/^#\/batch\/([^/]+)$/);
    if (mb)
        return { name: "batch", id: mb[1] };
    const m2 = hash.match(/^#\/pas\/activity\/([^/]+)$/);
    if (m2)
        return { name: "pas-activity", id: m2[1] };
    const m3 = hash.match(/^#\/pas\/patient\/([^/]+)$/);
    if (m3)
        return { name: "pas-patient", id: m3[1] };
    return { name: "home" };
}
export function onRouteChange(handler) {
    const fn = () => handler(parseRoute(location.hash));
    window.addEventListener("hashchange", fn);
    fn();
    return () => window.removeEventListener("hashchange", fn);
}
